import {Popover} from "../../dependencies/bootstrap";
import {findAll, onReady} from "../../../../modules/vegas/js/util";

function initPopover() {
	[...findAll('[data-bs-toggle="popover"]')].forEach(function (el) {
		new Popover(el)
	})
}

onReady(initPopover);
typeof onTurboRender !== 'undefined' && onTurboRender(initPopover);
